import './RefundEmail.css';
import React from 'react';
import { Form, useChanges } from '../../../../components/Form/Form';
import { Select } from '../../../../components/Form/Select/Select';
import { TextField } from '../../../../components/Form/TextField/TextField';
import { t } from '../../../../locales/translate';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { handleError } from '../../../../model/notification';
import { sendRefundEmail } from '../../../../model/order';
import { getEventName, Event } from '../../../../model/event';
import { KeyValueTable } from '../../../../components/KeyValueTable/KeyValueTable';
import classnames from 'classnames';
import { Stack } from '../../../../components/Stack/Stack';

interface Props {
  orderId: string;
  email?: string;
  events: Event[];
  controller: ModalController<{}>;
}

export const RefundEmail = ({ orderId, email, events, controller }: Props): JSX.Element => {
  const [, , model, trackChanges] = useChanges({
    email,
    productId: '',
  });

  async function handleOnSubmit(): Promise<void> {
    try {
      await sendRefundEmail({ ...model, orderId });
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <Stack>
            <TextField label={t.model.user.email} name="email" required />
            <Select
              label={t.model.product._name}
              name="productId"
              options={[
                { value: '', label: '' },
                ...events.map((event) => ({
                  value: event.id,
                  label: getEventName(event, { sku: true }),
                })),
              ]}
              defaultValue={events.length === 1 ? events[0].id : undefined}
              required
            />
            <KeyValueTable
              items={[
                {
                  key: t.model.event.massRefund.linkToRefundPage,
                  value: model.productId ? (
                    <span
                      className={classnames({
                        'refund-email--valid': form.valid,
                        'refund-email--invalid': !form.valid,
                      })}
                    >
                      {`https://${window.location.host}/refund?order_id=${orderId}&product_id=${model.productId}&email=${model.email}`}
                    </span>
                  ) : undefined,
                },
              ]}
            />
          </Stack>
        );
      }}
    </Form>
  );
};
